export default function Icon({
    className,
}: {
    className?: string;
}) {
  return (
    <svg
      className={className}
      viewBox="0 0 119 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_35_13742)">
        <g filter="url(#filter0_dd_35_13742)">
          <ellipse cx="20" cy="19.9999" rx="20" ry="19.9999" fill="#6B39F4" />
          <ellipse
            cx="20"
            cy="19.9999"
            rx="20"
            ry="19.9999"
            fill="url(#paint0_linear_35_13742)"
            fillOpacity="0.2"
          />
          <path
            d="M20 0.116211C30.9813 0.116211 39.8838 9.01881 39.8838 20C39.8837 30.9811 30.9812 39.8828 20 39.8828C9.01878 39.8828 0.11628 30.9811 0.116211 20C0.116211 9.01882 9.01874 0.11622 20 0.116211Z"
            stroke="url(#paint1_linear_35_13742)"
            strokeWidth="0.233333"
          />
        </g>
        <g filter="url(#filter1_d_35_13742)">
          <path
            d="M10.3995 29.5028V10.4004H14.2457L21.3995 19.8875H19.6047L26.5534 10.4004H30.3996V29.5028H26.4252V14.785L28.0149 15.144L20.656 24.6311H20.1431L13.0406 15.144L14.3739 14.785V29.5028H10.3995Z"
            fill="white"
          />
        </g>
        <path
          d="M83.2821 23.8174C83.2821 24.416 83.396 24.9445 83.6249 25.4023C83.8715 25.8427 84.2158 26.1948 84.6561 26.459C85.114 26.7054 85.6249 26.8291 86.1884 26.8291C86.7518 26.8291 87.254 26.7055 87.6942 26.459C88.1344 26.1948 88.478 25.8338 88.7245 25.376C88.9711 24.9181 89.0936 24.3714 89.0936 23.7373V15.3105H92.5546V29.6816H89.2792V27.9727C88.9455 28.5523 88.4876 29.008 87.9052 29.3389C87.1479 29.7791 86.2585 29.999 85.2372 29.999C84.1277 29.999 83.1587 29.7528 82.3309 29.2598C81.5207 28.7666 80.8953 28.0789 80.455 27.1982C80.0324 26.3177 79.8212 25.2873 79.8212 24.1074V15.3105H83.2821V23.8174ZM112.261 14.9932C113.441 14.9932 114.481 15.213 115.379 15.6533C116.277 16.076 116.973 16.6753 117.466 17.4502C117.976 18.2075 118.231 19.0968 118.231 20.1182V29.6816H114.956V28.1738C114.774 28.3749 114.58 28.5606 114.375 28.7305C113.864 29.1356 113.282 29.4527 112.631 29.6816C111.979 29.893 111.257 29.999 110.465 29.999C109.461 29.999 108.589 29.8316 107.849 29.4971C107.11 29.1624 106.537 28.6868 106.132 28.0703C105.727 27.4364 105.524 26.7055 105.524 25.8779C105.524 25.0855 105.7 24.381 106.053 23.7646C106.405 23.1306 106.951 22.6014 107.69 22.1787C108.43 21.756 109.364 21.4574 110.491 21.2812L114.771 20.583V20.1182C114.771 19.5018 114.524 18.991 114.031 18.5859C113.556 18.1633 112.921 17.9521 112.129 17.9521C111.389 17.9522 110.729 18.1545 110.147 18.5596C109.584 18.947 109.17 19.4667 108.906 20.1182L106.079 18.7451C106.361 17.9878 106.801 17.336 107.4 16.79C108.017 16.2265 108.739 15.7858 109.566 15.4688C110.394 15.1518 111.292 14.9932 112.261 14.9932ZM100.422 15.3105H103.724V18.4014H100.422V24.5566C100.422 25.0322 100.502 25.4378 100.66 25.7725C100.836 26.1068 101.1 26.3621 101.452 26.5381C101.822 26.7142 102.289 26.8027 102.852 26.8027C102.976 26.8027 103.117 26.794 103.275 26.7764C103.451 26.7588 103.619 26.7403 103.777 26.7227V29.6816C103.531 29.7169 103.249 29.7529 102.932 29.7881C102.615 29.8233 102.324 29.8408 102.059 29.8408C100.439 29.8407 99.1803 29.4 98.2821 28.5195C97.4016 27.6214 96.9609 26.3623 96.9608 24.7422V18.4014H94.4774V15.3105H94.7421C95.4463 15.3105 95.9923 15.1255 96.3798 14.7559C96.7672 14.386 96.9608 13.8481 96.9608 13.1436V12.0342H100.422V15.3105ZM60.6698 18.8867L67.0731 10H70.5077V29.6816H66.8885V16.3018L60.8114 24.3984H60.3885L54.286 16.0615V29.6816H50.6932V10H54.1278L60.6698 18.8867ZM77.1805 29.6816H73.7196V15.3105H77.1805V29.6816ZM111.151 23.8438C110.464 23.967 109.954 24.1869 109.619 24.5039C109.284 24.8209 109.117 25.2354 109.117 25.7461C109.117 26.239 109.302 26.6353 109.672 26.9346C110.059 27.2163 110.535 27.3574 111.099 27.3574C111.821 27.3574 112.455 27.2076 113.001 26.9082C113.564 26.5912 113.996 26.1593 114.296 25.6133C114.613 25.0675 114.771 24.4688 114.771 23.8174V23.2275L111.151 23.8438ZM77.1805 13.6982H73.7196V10H77.1805V13.6982Z"
          fill="#040405"
        />
      </g>
      <defs>
        <filter
          id="filter0_dd_35_13742"
          x="-1.86666"
          y="-0.699998"
          width="43.7333"
          height="43.7331"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="0.233333"
            operator="erode"
            in="SourceAlpha"
            result="effect1_dropShadow_35_13742"
          />
          <feOffset dy="0.933331" />
          <feGaussianBlur stdDeviation="0.933331" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0509804 0 0 0 0 0.0509804 0 0 0 0 0.0705882 0 0 0 0.02 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_35_13742"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="0.466665"
            operator="erode"
            in="SourceAlpha"
            result="effect2_dropShadow_35_13742"
          />
          <feOffset dy="1.16666" />
          <feGaussianBlur stdDeviation="1.16666" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0509804 0 0 0 0 0.0509804 0 0 0 0 0.0705882 0 0 0 0.04 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_35_13742"
            result="effect2_dropShadow_35_13742"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect2_dropShadow_35_13742"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d_35_13742"
          x="10.3995"
          y="10.4004"
          width="20.8576"
          height="20.3888"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="0.428782" dy="0.857564" />
          <feGaussianBlur stdDeviation="0.214391" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_35_13742"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_35_13742"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_35_13742"
          x1="20"
          y1="0"
          x2="20"
          y2="39.9997"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_35_13742"
          x1="20"
          y1="0"
          x2="20"
          y2="39.9997"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#6B39F4" stopOpacity="0" />
          <stop offset="1" stopColor="#6B39F4" />
        </linearGradient>
        <clipPath id="clip0_35_13742">
          <rect width="119" height="40" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export const displayName = "Icon";
